import React from 'react';
import logo from '../Assets/Pictures/turtle.png'
import { useTheme } from '../ThemeContext';
import Button from './Button';

export default function WelcomePage( {  
  openHowTo, 
  closeMenu, 
  openSignUp, 
  openSignIn, 
  openDataWarning } ) {

  const darkTheme = useTheme()

  const styles = {
    backgroundColor : darkTheme ? 'rgb(110 125 140)' : 'rgb(245, 245, 245)',
    color: darkTheme ? '#eee' : '#111',
  }

  return (
    <>
        <div 
            onClick={closeMenu}
            style={styles} 
            className="welcome-page w-screen flex-grow flex items-center justify-center"
        >
            <div className='welcome-container flex flex-col items-center font-quicksand gap-4 pb-20'>
                <div className='header flex items-center'>
                  <img src={logo} alt="logo" className='turtle-one h-20 md:h-28 mr-1'/>
                  <h1 className='font-pen text-9xl text-center mb-2'>Turtle</h1>
                  <img src={logo} alt="logo" className='h-20 md:h-28 ml-3'/>
                </div>
                <Button
                    color='green'
                    clickFunction={openSignIn}
                >
                    Sign In
                </Button>
                <div className='w-full flex flex-col items-center'>
                    <p className='text-xl pb-1'>
                        Don't have an account?  
                    </p>
                    <Button
                        color='green'
                        clickFunction={openSignUp}
                    >
                        Sign Up
                    </Button>
                    <p 
                        className='text-xl mt-2 mb-2'
                    >
                        <em>or</em>
                    </p>
                    <Button
                        color='green'
                        clickFunction={openDataWarning}
                    >
                      Continue as Guest
                    </Button>
                </div>
                <Button
                    color='yellow'
                    clickFunction={openHowTo}
                >
                    How To Play
                </Button>
            </div>
        </div>
    </>
    
  );
};
